export default "__VITE_ASSET__C11x5_lK__"